export default "__VITE_ASSET__Cveo$KCJ__"